<div class="search-wrapper px-3 mb-2 mb-md-3">
  <div class="search">
    <input (keyup.enter)="addSearchTerm($event)" class="form-control"
      [placeholder]="'Search machine or page ...' | translate"
      type="search">
    </div>

    @if (showSearchTerms) {
      <div class="search-terms pt-2 pb-1">
        @for (searchItem of searchItems; track searchItem) {
          <span
            class="badge badge-pill badge-light mr-2 mb-1">
            <span [innerText]="searchItem"></span>
            <span (click)="removeSearchTerm(searchItem)" class="fa-solid fa-xmark ml-1"></span>
          </span>
        }
      </div>
    }

    @if (displaySearchResults) {
      <scitis-search-result (loadMoreItems)="onLoadMoreItems()"
        (menuItemSelected)="onMenuItemSelected($event)"
        (resetSearch)="resetSearch()"
        [searchInProgress]="searchInProgress"
        [searchResultTotalCount]="searchResultsTotalCount"
        [searchResults]="searchResults"
        [searchTerms]="searchItems"
        [firebaseUserId]="firebaseUserId">
      </scitis-search-result>
    }


  </div>

